import { NgModule } from '@angular/core';
import { SliderComponent } from './slider.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [SliderComponent],
  imports: [
    CommonModule,
    FormsModule,
  ],
  exports: [SliderComponent]
})
export class SliderModule { }
